import React from "react"
import PropTypes from "prop-types"
import { selectAstrositesById } from "./slice"
import styled from "styled-components"
import { useSelector } from "react-redux"
import IDLink from "../../ui/IDLink"

const Name = styled.span`
  color: ${(props) => props.color};
`

const AstrositeName = ({ astrositeId, showLinkIcon = true }) => {
  const astrositesById = useSelector(selectAstrositesById)
  const astrosite = astrositesById[astrositeId]
  return astrosite ? (
    <IDLink to={`/astrosites/${astrositeId}`} showLinkIcon={showLinkIcon}>
      <Name color={astrosite.color}>{astrosite.name}</Name>{" "}
    </IDLink>
  ) : (
    "-"
  )
}

AstrositeName.propTypes = {
  astrositeId: PropTypes.string,
  showLinkIcon: PropTypes.bool,
}

export default AstrositeName
